import { render, staticRenderFns } from "./text-filter.vue?vue&type=template&id=2e43d4a0&scoped=true&"
import script from "./text-filter.vue?vue&type=script&lang=js&"
export * from "./text-filter.vue?vue&type=script&lang=js&"
import style0 from "./text-filter.vue?vue&type=style&index=0&id=2e43d4a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e43d4a0",
  null
  
)

export default component.exports